import { createFileRoute } from "@tanstack/react-router";
/**
 * Bulk Product Details Page
 *
 * This page shows the details of a product
 *
 * The bulkProductId param is required.
 */

import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import { getGetBulkProductQueryOptions } from "@/requests/gen/react-query/bulk-product";
import { BulkProductCard } from "@/components/product-cards/bulk-product-card";
import { BulkProductCrumbs } from "../-crumbs";
import { BulkProductTabs } from "./-bulk-product-tabs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_practice-360/bulk-product/$bulkProductId/",
)({
  loader: ({ context: { queryClient }, params: { bulkProductId } }) =>
    queryClient.ensureQueryData(
      getGetBulkProductQueryOptions(numericId(bulkProductId)),
    ),
  component: BulkProductDetailsPage,
});

function BulkProductDetailsPage() {
  const { bulkProductId } = Route.useParams();
  const { data: product, refetch } = useSuspenseQuery(
    suspenseOptions(getGetBulkProductQueryOptions(numericId(bulkProductId))),
  );

  const tabs = product ? <BulkProductTabs bulkProduct={product} /> : null;

  return (
    <div>
      <title>{`Bulk Product ${product?.catalog_product.product_base.name} - Legrande Health Portal`}</title>
      <BulkProductCrumbs />

      {product && (
        <div className="grid gap-6 xl:grid-cols-2 *:min-w-0">
          <div className={tabs ? undefined : "col-span-2 max-w-150 mx-auto"}>
            <BulkProductCard bulkProduct={product} refetch={refetch} />
          </div>
          {tabs}
        </div>
      )}
    </div>
  );
}
